import React, { useState, useEffect } from "react";
import style from "./asnstatus.module.css";
import MenuBar from "./MenuBarAdmin";
import { useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import DateRangePicker from "../Star/DateRangePicker.js";
import { toast } from "react-toastify";
import pdfIcon from "../Star/assets/pdf.png";
import { API_BASE_URL } from "../Star/config.js";


const ASNStatus = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const modeFromUrl = params.get("mode");
  const modeFromSession = sessionStorage.getItem("mode");

  const isEmbedded =
    (modeFromUrl && modeFromUrl.toLowerCase() === "admin") ||
    modeFromSession === "admin";

  if (isEmbedded) {
    sessionStorage.setItem("mode", "admin");
  }

  /* ================= ASN STATUS MASTER (UI ONLY) ================= */
  const ASN_STATUS_OPTIONS = [
    { value: "In Transit", label: "In Transit" },
    { value: "Gate Inward", label: "Gate Inward" },
    { value: "Booked", label: "Booked" },
  ];

  /* ================= STATE ================= */
  const [selectedASNStatus, setSelectedASNStatus] = useState("");

  const [selectedLocation, setSelectedLocation] = useState("");
  const [locations, setLocations] = useState([]);
  const [bookeddebitnoteData, setBookedDebitNoteData] = useState([]);
  const [downloadingDocEntry, setDownloadingDocEntry] = useState(null);
  const [vendors, setVendors] = useState([]);


  const vendorDataRaw = sessionStorage.getItem("vendordata");
  const vendorInfo = vendorDataRaw ? JSON.parse(vendorDataRaw) : null;
  const vendorCode = vendorInfo?.CardCode || "";
  const [selectedVendor, setSelectedVendor] = useState(vendorCode || "");

  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const [fromDate, setFromDate] = useState(
    firstDayOfMonth.toISOString().split("T")[0],
  );
  const [toDate, setToDate] = useState(
    lastDayOfMonth.toISOString().split("T")[0],
  );

  /* ================= HELPERS ================= */
  const formatDateForAPI = (date) => {
    const d = new Date(date);
    return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(
      2,
      "0",
    )}${String(d.getDate()).padStart(2, "0")}`;
  };

  const fetchVendors = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/masters/vednors?Key=U2FtcGxlRW5jcnlwdGVkS2V5`
      );

      setVendors(res.data || []);

    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };
  /* ================= API (STATUS=O MUST STAY) ================= */
  const fetchInwardBookingData = async (from, to, location, vendor) => {
    try {
      let finalVendor = vendor || "ALL"; // ✅ default ALL

      let url = `${API_BASE_URL}/InwardBooking?FromDt=${formatDateForAPI(from)}&ToDt=${formatDateForAPI(to)}&Status=O&Location=${location}&VendorCode=${finalVendor}`;

      const res = await axios.get(url);
      setBookedDebitNoteData(res.data || []);
    } catch (error) {
      console.error("Error fetching ASN data:", error);
    }
  };

  const fetchLocations = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/location`);
      if (Array.isArray(res.data)) setLocations(res.data);
    } catch {
      toast.error("Failed to fetch locations");
    }
  };

  /* ================= EFFECT ================= */
  // 1️⃣ Run only once
  useEffect(() => {
    fetchVendors();
    fetchLocations();
  }, []);

  // 2️⃣ Run when vendorCode is ready
  useEffect(() => {

    const start = moment().startOf("quarter").format("YYYY-MM-DD");
    const end = moment().endOf("quarter").format("YYYY-MM-DD");

    setFromDate(start);
    setToDate(end);

    fetchInwardBookingData(start, end, "", "");
  }, [vendorCode]);

  /* ================= UI-ONLY ASN FILTER ================= */
  const filteredData = selectedASNStatus
    ? bookeddebitnoteData.filter(
      (item) =>
        item.Status && item.Status.trim() === selectedASNStatus.trim(),
    )
    : bookeddebitnoteData;

  /* ================= PDF DOWNLOAD (UNCHANGED LOGIC) ================= */
  const handleDownloadPDF = async (po) => {
    try {
      setDownloadingDocEntry(po.DocEntry);

      const response = await fetch(
        `${API_BASE_URL}/InwardBooking/DownloadSAPPDF?DocNum=${po.DocEntry}`,
      );

      if (!response.ok) throw new Error("Failed to download PDF");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `ASNStatus_${po.StarDocNum}_${new Date()
        .toISOString()
        .slice(0, 10)}.pdf`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Could not download PDF.");
    } finally {
      setDownloadingDocEntry(null);
    }
  };

  return (
    <div className={style.PurchaseOrderDetails}>
      <div className={style.PurchaseOrderDetailsContainer}>
        <div className={style.MenuBarContainer}>
          <MenuBar />
        </div>
        <div className={style.MainPurchaseOrderDetailsContainer}>
          <div className={style.MenuNameDetails}>ASN Status</div>

          <div className={style.filterArea}>
            <div className={style.pofilter}>

              <div>Status</div>
              <select
                value={selectedASNStatus}
                onChange={(e) => setSelectedASNStatus(e.target.value)}
              >
                <option value="">All</option>
                {ASN_STATUS_OPTIONS.map((s) => (
                  <option key={s.value} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </select>

              <div>Location</div>
              <select
                value={selectedLocation}
                onChange={(e) => {
                  const loc = e.target.value;
                  setSelectedLocation(loc);
                  fetchInwardBookingData(fromDate, toDate, loc, selectedVendor);
                }}
              >
                <option value="">All</option>
                {locations.map((loc) => (
                  <option key={loc.Code} value={loc.Code}>
                    {loc.Location}
                  </option>
                ))}
              </select>

              <div>Vendor</div>
              <select
                value={selectedVendor}
                onChange={(e) => {
                  const vendor = e.target.value;
                  setSelectedVendor(vendor);

                  // call API again with vendor
                  fetchInwardBookingData(fromDate, toDate, selectedLocation, vendor);
                }}
              >
                <option value="">All</option>
                {vendors.map((v) => (
                  <option key={v.CardCode} value={v.CardCode}>
                    {v.CardName}
                  </option>
                ))}
              </select>
            </div>

            <div className={style.datearea}>
              <DateRangePicker
                onDateChange={(s, e) => {
                  setFromDate(s);
                  setToDate(e);
                  fetchInwardBookingData(s, e, selectedLocation, selectedVendor);
                }}
                startDate={fromDate}
                endDate={toDate}
              />
            </div>
          </div>

          <div className={style.MainArea}>
            <div className={style.BookedInvoicetable}>
              <table>
                <thead>
                  <tr>
                    <td style={{ display: "none" }}>DocEntry</td>

                    <td>Invoice #</td>
                    <td>Invoice Date</td>
                    <td>Taxable Amount</td>
                    <td>Tax Amount</td>
                    <td>Total Amount</td>
                    <td>ASN Status</td>
                    <td>Star Gate Entry #</td>
                    <td>Gate Entry Date</td>
                    <td>Star GRN #</td>
                    <td>Star GRN Date</td>
                    <td>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length ? (
                    filteredData.map((item, index) => (
                      <tr key={index}>
                        <td style={{ display: "none" }}>{item.DocEntry}</td>

                        <td>{item.Vendor_Invoice_No || "-"}</td>
                        <td>{item.Vendor_Invoice_Date || "-"}</td>
                        <td className="text-end amount-cell">
                          {item.DocCur}{" "}
                          {Number(item.Taxable_Amount).toLocaleString("en-IN")}
                        </td>
                        <td className="text-end amount-cell">
                          {item.DocCur}{" "}
                          {Number(item.Tax_Amount).toLocaleString("en-IN")}
                        </td>
                        <td className="text-end amount-cell">
                          {item.DocCur}{" "}
                          {Number(item.Total_Amount).toLocaleString("en-IN")}
                        </td>
                        <td>
                          <span
                            className={`${style.statusBadge} ${style[
                              `status_${item.Status?.replace(/\s+/g, "")}`
                            ]
                              }`}
                          >
                            {item.Status || "-"}
                          </span>
                        </td>
                        <td>{item.Star_Gate_Entry_No || "-"}</td>
                        <td>{item.Gate_Entry_Date || "-"}</td>
                        <td>{item.Star_GRN_No || "-"}</td>
                        <td>{item.Star_GRN_Date || "-"}</td>

                        <td
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          {downloadingDocEntry === item.DocEntry ? (
                            <span style={{ fontSize: 12, color: "#666" }}>
                              Downloading...
                            </span>
                          ) : (
                            <img
                              src={pdfIcon}
                              alt="PDF"
                              title={
                                Number(item.ShowAction) === 0
                                  ? "Download not allowed"
                                  : "Download PDF"
                              }
                              style={{
                                width: 20,
                                height: 20,
                                cursor:
                                  Number(item.ShowAction) === 0
                                    ? "not-allowed"
                                    : "pointer",
                                opacity:
                                  Number(item.ShowAction) === 0 ? 0.4 : 1,
                                pointerEvents:
                                  Number(item.ShowAction) === 0
                                    ? "none"
                                    : "auto",
                              }}
                              onClick={() => {
                                if (Number(item.ShowAction) !== 0) {
                                  handleDownloadPDF(item);
                                }
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" style={{ textAlign: "center" }}>
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ASNStatus;
